module.exports = "/assets/data/8cf69616043eebeee6c92a3d43e0aef6-WR12.data.json";